import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../layout';
import { DoneScheduledActionsTable } from './components/DoneScheduledActionsTable';

export const CompletedScheduledActions = () => {
  const { t } = useTranslation('page-admin-my-tasks');
  return (
    <PageLayout>
      <PageHeader backRouteTo={''} title={t('doneTasks.title')} />
      <PageContent sx={{ alignItems: 'flex-start' }}>
        <DoneScheduledActionsTable />
      </PageContent>
    </PageLayout>
  );
};
